﻿// Import general mixin for shared functionality.
import mixin from './mixin';
import ApiSourceSet from './components/ApiSourceSet.vue';
import Skeleton from './components/Skeleton.vue';

// Import axios for API consuming in a clean interface.
const axios = require('axios');

const newsOverviewApp = {
    mixins: [mixin],
    components: { ApiSourceSet, Skeleton },
    data() {
        return {
            dataApi: '',
            dataLimit: 12,
            dataGuid: '',
            dataLanguage: '',

            loading: false,
            data: null,
            page: 0,
            initialLoad: true,
        }
    },
    computed: {
        itemsSet() {
            return this.data && this.data.items && this.data.items.length;
        },
        offset() {
            return this.initialLoad ? 0 : this.dataLimit * this.page;
        },
        queryParams() {
            const urlParams = new URLSearchParams();
            urlParams.set('newsOverviewNodeId', this.dataGuid);
            urlParams.set('cultureCode', this.dataLanguage);
            urlParams.set('limit', this.dataLimit);
            urlParams.set('offset', this.offset);
            return urlParams.toString();
        },
    },
    methods: {
        async init() {
            this.loading = true;

            if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
            if (this.$el.dataset.guid) this.dataGuid = this.$el.dataset.guid;
            if (this.$el.dataset.language) this.dataLanguage = this.$el.dataset.language;
            if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);

            const urlParams = new URLSearchParams(window.location.search);

            let pageParam = urlParams.has('page') ? parseInt(urlParams.get('page')) : 0;
            if (pageParam) urlParams.delete('page');

            let tempLimit = this.dataLimit;
            if (pageParam) {
                this.page = pageParam;
                this.dataLimit = this.dataLimit + (this.dataLimit * this.page);
            } 

            const response = await this.fetchData();
            this.setData(response);
            this.dataLimit = tempLimit;

            this.initialLoad = false;
            this.loading = false;
        },
        async fetchData() {
            try {
                const response = await axios.get(`${this.dataApi}?${this.queryParams}`);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        async loadMore() {
            this.page++;
            const response = await this.fetchData();
            this.setData(response);
            this.updateUrl();
        },
        setData(response) {
            if (!response || response.status != 200) return;
            if (!this.data) {
                this.data = response.data;
            }
            else {
                if (response.data.items && response.data.items.length) {
                    response.data.items.forEach(item => {
                        this.data.items.push(item);
                    })
                }
            }
        },
        updateUrl() {
            if (!this.page) {
                history.pushState({}, null, window.location.pathname);
                return;
            }
            const urlParams = new URLSearchParams();
            if (this.page) urlParams.append('page', this.page);
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
        },
    },
    mounted() {
        this.init();
    },
};

export default newsOverviewApp;
